(function () {
  function initSlideshow(el) {
    if (!el) return;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasMultiple    = el.dataset.multiple === 'true';
    var swiperEl       = el.querySelector('.swiper');
    var prevEl         = el.querySelector('.slideshow-prev');
    var nextEl         = el.querySelector('.slideshow-next');
    new Swiper(swiperEl, {
      loop:       hasMultiple,
      speed:      parseInt(el.dataset.speed, 10) || 800,
      grabCursor: false,
      effect:     'fade',
      fadeEffect: { crossFade: true },
      keyboard: { enabled: true, onlyInViewport: true },
      observer: true,
      observeParents: true,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      autoplay: (el.dataset.autoplay === 'true' && !prefersReduced && hasMultiple)
        ? {
            delay:                parseInt(el.dataset.delay, 10) || 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter:    false,
          }
        : false,
      navigation: (hasMultiple && prevEl && nextEl)
        ? { prevEl: prevEl, nextEl: nextEl }
        : false,
      pagination: (hasMultiple && el.dataset.showPagination === 'true')
        ? {
            el:        el.querySelector('.slideshow-pagination'),
            clickable: true,
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            type: "progressbar"
          }
        : false,
      on: {
        init: function (swiper) {
          var active = swiper.slides[swiper.activeIndex];
          if (active) active.classList.add('is-active', 'no-animation');
        },
        slideChangeTransitionStart: function (swiper) {
          swiper.slides.forEach(function (slide) {
            slide.classList.remove('is-active', 'no-animation');
          });
        },
        slideChangeTransitionEnd: function (swiper) {
          var active = swiper.slides[swiper.activeIndex];
          if (active) active.classList.add('is-active');
        },
      },
    });
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.slideshow[data-section-id]').forEach(function (el) {
      initSlideshow(el);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var slideshows = document.querySelectorAll('.slideshow[data-section-id="' + e.detail.sectionId + '"]');
    slideshows.forEach(function (el) { initSlideshow(el); });
  });
})();